

uniform float uGrayIntensity;
varying vec2 vUv;
uniform sampler2D uDisplacementTexture;



//uniform sampler2D uTextureList[3];
uniform sampler2D uTexture;

float PI = 3.141592653589793;


mat2 getRotM(float angle) {
  float s = sin(angle);
  float c = cos(angle);
  return mat2(c, -s, s, c);
}

vec4 sampleTexture(float index, sampler2D textures[3], vec2 uv) {
    index=mod(index, 3.);
    if (index == 0.) return texture2D(textures[0], uv);
    if (index == 1.) return texture2D(textures[1], uv);
    if (index == 2.) return texture2D(textures[2], uv);
    return vec4(0.0); // Default case
}
void main()
{   
    
    
   //vec4 textureColor = vec4(1., 0., 0., 1.);
    
 
    /*vec4 textureColor = texture2D(uTexture, vUv);
    gl_FragColor=textureColor;*/
     //gl_FragColor = mix(textureColor, vec4(1., 0., 0., 1.),1.);
   // gl_FragColor=vec4(1., 0., 0., 1.);




    vec4 displacement = texture2D(uDisplacementTexture, vUv);
    displacement=smoothstep(0.1, 1., displacement);

    float theta = displacement.r*2.*PI;
    vec2 dir = vec2(sin(theta), cos(theta));

    vec2 uv = vUv+dir*displacement.r*0.25;

    vec4 textureColor = texture2D(uTexture, uv);
   
    gl_FragColor = textureColor;
    

  /*
   vec4 disp = texture2D(uDisplacementTexture2, vUv);
    vec2 dispVec = vec2(disp.r, disp.g);

   // vec2 uv = 0.5 * gl_FragCoord.xy / (uRes.xy) ;
    //vec2 myUV = (uv - vec2(0.5))*uRes.zw + vec2(0.5);

    vec4 displacement = texture2D(uDisplacementTexture, vUv);
    displacement=smoothstep(0.1, 1., displacement);

    float theta = displacement.r*2.*PI;
    vec2 dir = vec2(sin(theta), cos(theta));

    vec2 uv = vUv+dir*displacement.r*0.02;

    vec2 distortedPosition1 = uv + getRotM(uAngle1) * 0.3*dispVec   * uFactor;
    vec2 distortedPosition2 = uv + getRotM(uAngle2) * 0.3*dispVec  * (1.0 - uFactor);

    vec4 _texture1 = sampleTexture(uIndexTexture, uTextureList, distortedPosition1);
   
    vec4 _texture2 = sampleTexture(uIndexTexture+1., uTextureList, distortedPosition2);

     float grayscale1 = (_texture1.r + _texture1.g + _texture1.b) / 3.0;
    float grayscale2 = (_texture2.r + _texture2.g + _texture2.b) / 3.0;

  gl_FragColor = mix(vec4(grayscale1,grayscale1,grayscale1,1. ), vec4(grayscale2,grayscale2,grayscale2,1. ), uFactor);*/
}